import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";
import {
  CrearPeriodontogramaPayload,
  UltimoPeriodontograma,
  EstadoPeriodontograma,
} from "app/models/periodontograma.interface";

@Injectable({ providedIn: "root" })
export class PeriodontogramaService {
  private base = GlobalVariable.BASE_API_URL + "api/periodontograma";

  constructor(private http: HttpClient) {}

  ultimoPorPaciente(idPaciente: number): Observable<UltimoPeriodontograma> {
    return this.http.get<UltimoPeriodontograma>(`${this.base}/ultimo-por-paciente/${idPaciente}`);
  }

  crear(payload: CrearPeriodontogramaPayload): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.base}`, payload);
  }

  actualizar(
    id: number,
    payload: {
      periodontograma_estado?: EstadoPeriodontograma;
      observaciones?: string | null;
      denticion?: string;
    },
  ): Observable<{ id: number }> {
    return this.http.put<{ id: number }>(`${this.base}/${id}`, payload);
  }
}
